import { SdkApplication } from '@nexla/@types';
import { find } from 'lodash';
import { useSelector } from 'react-redux';
import {
  DELETE_SDK_APPLICATION,
  PAUSE_SDK_APPLICATION,
  ACTIVATE_SDK_APPLICATION,
  ROTATE_SERVICE_KEY,
} from 'js/constants/processTypes';
import { useGetServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useGetServiceKeys';

export function useSdkApplicationProcesses(data: SdkApplication) {
  const state = useSelector((s: any) => s);
  const processes = useSelector((s: any) => s.processes?.all ?? []);
  const allServiceKeys = useGetServiceKeys();

  const id = data.id;
  const linkedKeyIds = (allServiceKeys ?? [])
    .filter((key) => key?.sdk_application_id === id)
    .map((key) => key.id);

  return {
    isPausing: !!find(processes, { type: PAUSE_SDK_APPLICATION, id }),
    isActivating: !!find(processes, { type: ACTIVATE_SDK_APPLICATION, id }),
    isDeleting: !!find(processes, { type: DELETE_SDK_APPLICATION, id }),
    isRotating: linkedKeyIds.some(
      (keyId) => !!find(processes, { type: ROTATE_SERVICE_KEY, id: keyId }),
    ),
  };
}
